<template>
  <v-app id="app">
    <router-view name="sidebar"></router-view>
    <transition
      :name="transitionName"
      mode="out-in"
      @beforeLeave="beforeLeave"
      @enter="enter"
      @afterEnter="afterEnter"
    >
      <router-view />
    </transition>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import jwtDecode from "jwt-decode";
const DEFAULT_TRANSITION = "fade";
export default {
  name: "App",
  data() {
    return {
      transitionName: DEFAULT_TRANSITION,
      prevHeight: 0
    };
  },
  methods: {
    ...mapActions(["setToken", "setUser"]),
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    }
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;

      if (transitionName === "slide") {
        const toDepth = to.path.split("/").length;
        const fromDepth = from.path.split("/").length;
        transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
      }

      this.transitionName = transitionName || DEFAULT_TRANSITION;

      next();
    });
    const token = localStorage.getItem("token");
    
  },
  mounted() {
    // const token = localStorage.getItem("token");
    // if (token) {
    //   //
    // } else {
    //   if (this.$route.path.indexOf("reset") > -1) {
    //   } else {
    //     this.$router.push("/");
    //   }
    // }
  },
  computed: {
    path() {
      return this.$route.path;
    }
  }
};
</script>
<style>
html,
body {
}
#app {
  background: radial-gradient(rgb(49, 49, 49), rgb(0, 0, 0));
  position: relative;
  overflow: hidden;
  font-family: "Montserrat";
}
.inner-section {
  margin-left: 250px;
  min-height: calc(100vh - 70px);
}
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
